// src/components/ReservationsSection.js
import React, { useEffect, useState } from "react";
import ReservationCard from "./cart/ReservationCard";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import LoadingAnimation from "./LoadingAnimation";

const ReservationsSection = () => {
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReservations = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "reservations"));
        const reservationsData = querySnapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((r) => !r.isHidden);
        setReservations(reservationsData);
      } catch (error) {
        console.error("❌ Error fetching reservations:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReservations();
  }, []);

  return (
    <div className="job-section padding-container">
      <style>{`
        .job .Grid-3-box {
          align-items: stretch;
        }
        .job .Grid-3-box > * {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
      `}</style>

      <div className="page-wrapper">
        <div className="job">
          <h1 className="job-h1">
            FEATURED <span className="orange-text">OPPORTUNITIES</span>
          </h1>

          <div className="Grid-3-box">
            {loading ? (
              <LoadingAnimation text="Loading Featured Opportunities..." />
            ) : reservations.length > 0 ? (
              reservations.map((reservation) => (
                <ReservationCard
                  key={reservation.id}
                  id={reservation.id}
                  date={reservation.date}
                  type={reservation.type}
                  gender={reservation.gender}
                  description={reservation.description} // 👈 ADD THIS LINE
                />
              ))
            ) : (
              <div style={{
                gridColumn: "1 / -1",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "40px 20px",
                textAlign: "center",
              }}>
                <img
                  src="/assets/Images/Job hunt-amico.svg"
                  alt="No opportunities found"
                  style={{ width: "320px", maxWidth: "100%" }}
                />
                <h3 style={{ fontSize: "20px", fontWeight: "600", color: "#333", marginBottom: "8px" }}>
                  No Opportunities Available Yet
                </h3>
                <p style={{ fontSize: "15px", color: "#888", maxWidth: "360px" }}>
                  Check back later for new opportunities.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReservationsSection;